import { Component, OnInit } from "@angular/core";
import { AdminTimeEventEmitterBo } from "./admin-time.modal";
@Component({
  selector: "app-admin-time",
  templateUrl: "./admin-time.component.html",
  styleUrls: ["./admin-time.component.scss"],
})
export class AdminTimeComponent implements OnInit {
  AdminTimeEditList: boolean = false;
  constructor() {}
  ngOnInit(): void {}
  isListorUpdateView: AdminTimeEventEmitterBo = {
    isCreate: false,
    isClose: false,
    getListDetails: null,
    EmployeeDropDown: null,
    EditEntryTypeList:null
  };
  EmitChildComponent(event: AdminTimeEventEmitterBo) {
    this.AdminTimeEditList = event.isCreate;
    this.isListorUpdateView = event;
  }
}
